<i18n>
{
	"en": {
		"noDeviationsFound": "No deviations were found that match this search. Try expanding your search criteria.",
		"deviationsFound": "No deviations found | {count} deviation found | {count} deviations found",
		"newDeviation": "New deviation"
	},

	"no": {
		"noDeviationsFound": "Vi fant ingen avvik som matcher dette søket. Prøv å utvide søkekriteriene.",
		"deviationsFound": "Ingen avvik | {count} tilgjengelig avvik | {count} avvik",
		"newDeviation": "Nytt avvik"
	}
}
</i18n>

<template>
	<t-vertical-panel :hideSubHeader="!deviationsFound" class="deviation-list">
		<div slot="header" class="deviation-list-header">
			<t-panel-header icon="warning-sign">
				{{ $tc('deviationsFound', deviationsFound) }}
			</t-panel-header>
		</div>

		<div slot="sub-header" class="deviation-list-sub-header">
			<t-button
				:value="$t('newDeviation')"
				appearance="minimal"
				type="bp"
				iconBefore="plus"
				@click="openNewDeviation"
			/>
		</div>

		<div class="deviation-list-content">
			<!-- Key disables grid component reuse. Fixes localStorageId changing between views. -->
			<DeviationGrid
				v-if="deviations"
				ref="grid"
				:key="localStorageId"
				:localStorageId="localStorageId"
				:deviations="deviations"
				@rowDoubleClick="onEditDeviation"
				@enter="onEditDeviation"
			/>

			<t-no-content-panel
				v-else
				:text="$t('noDeviationsFound')"
				icon="truck-front"
			/>
			<t-overlay
				:isShown="deviationsLoading"
				loaderMarginBottom="50px"
				absolute
				loader
			/>

		</div>
	</t-vertical-panel>
</template>

<script>
import { mapDynamicState } from '@/core/mapDynamic';
import { mapActions as mapDeviationActions } from '@/modules/newDeviation/store/newDeviation.store.js';
import {
	eventBus,
} from '@/core';

import DeviationGrid from '@/modules/deviations/DeviationGrid';

export default {
	name: 'DeviationList',
	components: { DeviationGrid },

	computed: {
		...mapDynamicState('computedStoreNamespace', [
			'deviations',
			'deviationsLoading',
		]),
		searchId() {
			return this.$route.params.searchId || -1;
		},
		computedStoreNamespace() {
			return `deviationSearch/${this.searchId}`;
		},
		localStorageId() {
			return `deviationSearchList/${this.searchId}`;
		},
		deviationsFound() {
			return this.deviations.length;
		},
	},

	methods: {
		...mapDeviationActions([
			'returnDeviation',
			'newDeviation',
			'loadDeviation',
		]),
		async openNewDeviation() {
			let newDeviation = await (await this.returnDeviation(this.newDeviation))();
			if (newDeviation && newDeviation.id) {
				eventBus.$emit('refreshDeviationList');
			}
		},

		async onEditDeviation(id) {
			let deviation = undefined;
			if (id) {
				deviation = this.deviations.find(x => x.id === id);
			} else {
				let selectedItems = this.$refs.grid.getSelectedItems();
				if (selectedItems.length > 1) return;
				deviation = selectedItems[0];
			}
			if (!deviation) return;
			let updatedDeviation = await (await this.returnDeviation(this.loadDeviation))(deviation.id);
			if (updatedDeviation) eventBus.$emit('refreshDeviationList');
		},
	},
};
</script>

<style lang="scss" scoped>
.deviation-list {
	.deviation-list-header {
		height: 100%;
		display:flex;
		align-items: center;
		padding-left: 15px;
	}

	.deviation-list-sub-header {
		display:flex;
		padding: 0px 15px;
		height: 100%;
		align-items: center;
		justify-content: space-between;
	}

	.deviation-list-content {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 5px;
	}
}
</style>
